"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.importMonthlySigningKpi = exports.importMonthlySalesKpi = exports.getMonthlySigningKpiList = exports.getMonthlySalesKpiList = exports.exportMonthlySigningKpi = exports.exportMonthlySalesKpi = exports.default = void 0;
var _request = _interopRequireDefault(require("@/http/request"));
/** package */

// 49.3. (L_MonthlySalesKpi)月度销售KPI设置表;列表
var getMonthlySalesKpiList = exports.getMonthlySalesKpiList = function getMonthlySalesKpiList(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/monthlySalesKpi/list",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 49.2. (E_SalesKpi)销量kpi导出
var exportMonthlySalesKpi = exports.exportMonthlySalesKpi = function exportMonthlySalesKpi(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/monthlySalesKpi/export",
    method: 'post',
    data: data,
    cancelToken: cancelToken,
    responseType: 'blob'
  });
};

// 49.1. (I_SalesKpi)销量KPI导入
var importMonthlySalesKpi = exports.importMonthlySalesKpi = function importMonthlySalesKpi(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/monthlySalesKpi/import",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 50.1. (L_MonthlySigningKpi)月度销售签约KPI设置表;列表
var getMonthlySigningKpiList = exports.getMonthlySigningKpiList = function getMonthlySigningKpiList(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/monthlySigningKpi/list",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 50.3. (E_SigningKpi)签约kpi导出
var exportMonthlySigningKpi = exports.exportMonthlySigningKpi = function exportMonthlySigningKpi(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/monthlySigningKpi/export",
    method: 'post',
    data: data,
    cancelToken: cancelToken,
    responseType: 'blob'
  });
};

// 50.2. (I_SigningKpi)签约KPI导入
var importMonthlySigningKpi = exports.importMonthlySigningKpi = function importMonthlySigningKpi(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/monthlySigningKpi/import",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};
var _default = exports.default = {
  getMonthlySalesKpiList: getMonthlySalesKpiList,
  exportMonthlySalesKpi: exportMonthlySalesKpi,
  importMonthlySalesKpi: importMonthlySalesKpi,
  getMonthlySigningKpiList: getMonthlySigningKpiList,
  exportMonthlySigningKpi: exportMonthlySigningKpi,
  importMonthlySigningKpi: importMonthlySigningKpi
};